import { Button } from '@eventbrite/eds-button';
import { isMediumWideDown } from '@eventbrite/eds-utils';
import { gettext } from '@eventbrite/i18n';
import { $FixMe } from '@eventbrite/ts-utils';
import loadable from '@loadable/component';
import React, { useEffect, useState } from 'react';
import { SearchResponseEventsData } from '../../../../utils/transformation';

export type LazyMapPanelContainerProps = {
    isOnline: boolean;
    isLoading: boolean;
    events: SearchResponseEventsData;
};

const LoadMapPanel = (props: { onClick: () => void; mounted: boolean }) =>
    props.mounted ? (
        <div
            className="eds-show-up-mw"
            style={{ position: 'fixed', top: '50%', right: '10%' }}
        >
            <Button data-testid="load-map-panel-btn" onClick={props.onClick}>
                {gettext('Load map')}
            </Button>
        </div>
    ) : null;

const lazyLoadMapPanel = () =>
    loadable(() => import('./MapPanelContainer'), {
        fallback: <div />,
        resolveComponent: (component: { MapPanelContainer: React.ReactNode }) =>
            component.MapPanelContainer,
    });

export const LazyMapPanelContainer = ({
    isOnline,
    ...props
}: LazyMapPanelContainerProps) => {
    // Storing mounted status in state because we don't want to
    // render the "load" fallback experience on the server for desktop
    const [{ component: LazyComponent, mounted }, setLazyComponent] = useState<{
        component: $FixMe;
        mounted: boolean;
    }>({
        component: null,
        mounted: false,
    });

    useEffect(() => {
        if (!isMediumWideDown() && !isOnline) {
            setLazyComponent({ component: lazyLoadMapPanel(), mounted: true });
        } else {
            setLazyComponent({ component: null, mounted: true });
        }
    }, [isOnline]);

    if (LazyComponent) {
        return <LazyComponent {...props} />;
    } else if (isOnline) {
        return null;
    } else {
        return (
            <LoadMapPanel
                onClick={() =>
                    setLazyComponent({
                        component: lazyLoadMapPanel(),
                        mounted: true,
                    })
                }
                mounted={mounted}
            />
        );
    }
};
